import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { ConstantService } from './constant.service';
import { HelperService } from './helper.service';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';
import { throwError, Observable, Observer } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded'
  })
};

const options = {
  headers: new HttpHeaders({
    // 'Content-Type': 'application/json',
    // 'mode': 'no-cors'
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true'
    // 'Access-Control-Allow-Origin': 'http://worldtimeapi.org/api/ip',
  })
}


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private _http: HttpClient,
    private _constantSvc: ConstantService,
    private helperSvc: HelperService,
    private authSvc: AuthService) {

  }


  constUrl = environment.APIBaseURL;

  // postService(url: string, data: any): Observable<any> {
  //   return new Observable<any>((observer: Observer<any>) => {
  //     this.helperSvc.loaderStart();
  //     this._http.post(this.constUrl + url, data)
  //       .subscribe(
  //         response => {
  //           observer.next(response);
  //           observer.complete();
  //           this.helperSvc.loaderStop();
  //         },
  //         (error: Response) => {
  //           this.errorHandler(error);
  //           observer.complete();
  //           this.helperSvc.loaderStop();
  //         }
  //       );
  //   });
  // }


  postService(url: string, data: any): Observable<any> {
    return new Observable<any>((observer: Observer<any>) => {
      this.helperSvc.loaderStart();
      this._http.post(this.constUrl + url, data)
        .toPromise().then((response: any) => {
          // this.tokenStorage.setToken(response.token);
          observer.next(response);
          observer.complete();
          this.helperSvc.loaderStop();
        },
          (error: Response) => {
            observer.complete();
            this.helperSvc.loaderStop();
            this.errorHandler(error);
          }
        )
    });
  }

  // getService(url: string, params: any): Observable<any> {
  //   return new Observable<any>((observer: Observer<any>) => {
  //     this.helperSvc.loaderStart();
  //     this._http.get<any>(this.constUrl+url + params)
  //       .subscribe(
  //         response => {
  //           // this.tokenStorage.setToken(response.token);
  //           console.log("this",this.constUrl + url + params)
  //           observer.next(response);
  //           observer.complete();
  //           this.helperSvc.loaderStop();
  //         },
  //         (error: Response) => {
  //           observer.complete();
  //           this.helperSvc.loaderStop();
  //           this.errorHandler(error);
  //         }
  //       );
  //   });
  // }

  getService(url: string, params: any): Observable<any> {
    return new Observable<any>((observer: Observer<any>) => {
      this.helperSvc.loaderStart();
      this._http.get<any>(this.constUrl + url + params)
        .toPromise().then((response: any) => {
          // this.tokenStorage.setToken(response.token);
          observer.next(response);
          observer.complete();
          // console.log("this",this.constUrl + url + params)
          this.helperSvc.loaderStop();
        },
          (error: Response) => {
            observer.complete();
            this.helperSvc.loaderStop();
            this.errorHandler(error);
          }
        )
    
    });
  }

  // putService(url: string, data: any): Observable<any> {
  //   return new Observable<any>((observer: Observer<any>) => {
  //     this.helperSvc.loaderStop();
  //     this._http.put(this.constUrl + url, data)
  //       .subscribe(
  //         response => {
  //           observer.next(response);
  //           observer.complete();
  //           this.helperSvc.loaderStop();
  //         },
  //         (error: Response) => {
  //           this.errorHandler(error);
  //           observer.complete();
  //           this.helperSvc.loaderStop();
  //         }
  //       );
  //   });
  // }

  putService(url: string, data: any): Observable<any> {
    return new Observable<any>((observer: Observer<any>) => {
      this.helperSvc.loaderStop();
      this._http.put(this.constUrl + url, data)
        .toPromise().then((response: any) => {
          // this.tokenStorage.setToken(response.token);
          observer.next(response);
          observer.complete();
          this.helperSvc.loaderStop();
        },
          (error: Response) => {
            observer.complete();
            this.helperSvc.loaderStop();
            this.errorHandler(error);
          }
        )
    });
  }

  // deleteService(url: string, params: any): Observable<any> {
  //   return new Observable<any>((observer: Observer<any>) => {
  //     this.helperSvc.loaderStart();
  //     this._http.delete(this.constUrl + url + params)
  //       .subscribe(
  //         response => {
  //           observer.next(response);
  //           observer.complete();
  //           this.helperSvc.loaderStop();
  //         },
  //         (error: Response) => {
  //           this.errorHandler(error);
  //           observer.complete();
  //           this.helperSvc.loaderStop();
  //         }
  //       );
  //   });
  // }

  deleteService(url: string, params: any): Observable<any> {
    return new Observable<any>((observer: Observer<any>) => {
      this.helperSvc.loaderStart();
      this._http.delete(this.constUrl + url + params)
        .toPromise().then((response: any) => {
          // this.tokenStorage.setToken(response.token);
          observer.next(response);
          observer.complete();
          this.helperSvc.loaderStop();
        },
          (error: Response) => {
            observer.complete();
            this.helperSvc.loaderStop();
            this.errorHandler(error);
          }
        )
    });
  }

  private errorHandler(error: any): void {
    return error;
  }
}